import React, { Component } from "react";
import { injectIntl, IntlShape } from "@ai360/core/intl";

import { DataTable } from "~/core";
import { withCrud } from "~/hocs";
import { FormattingHelpers } from "@ai360/core";
import { memoizeFormattedRecords } from "~/admin/utils";

import { service, actions } from "./log-data";
import { messages } from "../../agBytes/i18n-messages";

interface INutrientTargetValueLogProps {
    intl: IntlShape;
    records?: Record<string, unknown>[];
}

export class NutrientTargetValueLog_ extends Component<INutrientTargetValueLogProps> {
    getFormattedRecords = memoizeFormattedRecords(FormattingHelpers.formatLogDetailText);
    render(): JSX.Element {
        return (
            <div>
                <DataTable
                    service={service}
                    isCheckbox={false}
                    showFilterInput={false}
                    messages={messages}
                    {...this.props}
                    records={this.getFormattedRecords(this.props.records)}
                />
            </div>
        );
    }
}
export const NutrientTargetValueLog = injectIntl(
    withCrud(NutrientTargetValueLog_, service, actions)
);
